import React, { useEffect, useState } from "react";
import ScopeSequenceEditorContent from "./curriculum/ScopeSequenceEditorContent";
import "./ScopeSequenceEditorModal.css";

const ScopeSequenceEditorModal = ({ isOpen, onClose, courses = [] }) => {
  const [selectedCourseId, setSelectedCourseId] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    setSelectedCourseId((prev) => prev || courses[0]?.id || "");
  }, [courses, isOpen]);

  if (!isOpen) return null;

  return (
    <div className="scope-editor-modal" onClick={onClose}>
      <div className="scope-editor-panel" onClick={(e) => e.stopPropagation()}>
        <div className="scope-editor-header">
          <div>
            <h3>Scope &amp; Sequence Editor</h3>
            <p>Edit pacing rows from `scope_sequence_entries` by course and year.</p>
          </div>
          <div className="scope-editor-header-actions">
            <button type="button" className="scope-editor-close-btn" onClick={onClose}>
              Close
            </button>
          </div>
        </div>

        <div className="scope-editor-controls">
          <label htmlFor="scope-editor-course">
            Course
            <select
              id="scope-editor-course"
              value={selectedCourseId}
              onChange={(e) => setSelectedCourseId(e.target.value)}
            >
              {courses.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </select>
          </label>
        </div>

        {selectedCourseId && (
          <ScopeSequenceEditorContent courseId={selectedCourseId} />
        )}
      </div>
    </div>
  );
};

export default ScopeSequenceEditorModal;
